import "../styles/global.css";

import NextAppModule from "@uhg-abyss/core/next-app";

const ResolvedNextApp = NextAppModule?.default ?? NextAppModule?.App ?? NextAppModule;

export default function App(appProps) {
  if (typeof ResolvedNextApp === "function") {
    return <ResolvedNextApp {...appProps} />;
  }

  const { Component, pageProps } = appProps;
  return <Component {...pageProps} />;
}
